const WORDS_PER_MINUTE = 200

/** Leading slash, lowercase, no trailing slash. "" and "/" both mean the home page. */
export const normalisePath = (input: string): string => {
  const trimmed = input.trim().toLowerCase().replace(/\s+/g, "-")
  if (!trimmed || trimmed === "/") return "/"
  const withLeading = trimmed.startsWith("/") ? trimmed : `/${trimmed}`
  return withLeading.replace(/\/+$/, "") || "/"
}

export const slugify = (input: string): string =>
  input
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")

export const stripHtml = (html: string): string =>
  html
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim()

export const wordCount = (html: string): number => {
  const text = stripHtml(html)
  return text ? text.split(" ").length : 0
}

export const readingMinutes = (html: string): number => Math.max(1, Math.round(wordCount(html) / WORDS_PER_MINUTE))

export const formatDate = (value: string | null): string => {
  if (!value) return "—"
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return "—"
  return date.toLocaleDateString(undefined, { day: "2-digit", month: "2-digit", year: "numeric" })
}

export const formatDateTime = (value: string | null): string => {
  if (!value) return "—"
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return "—"
  return date.toLocaleString(undefined, { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })
}

export const formatBytes = (bytes: number): string => {
  if (!bytes) return "0 B"
  const units = ["B", "KB", "MB", "GB"]
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1)
  return `${(bytes / 1024 ** exponent).toFixed(exponent === 0 ? 0 : 1)} ${units[exponent]}`
}
